// extracted by css-extract-rspack-plugin
export default {"cls1":"UserTaggingPingBodyStyles-cls1_2E9","cls2":"UserTaggingPingBodyStyles-cls2_Ix2 UserTaggingPingBodyStyles-cls1_2E9"};